import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { InputDate } from "../../../theme/Input/InputDate";
import { BankAccountSelect } from "../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { _AddBanking, _Apply, _BankingConciliation, _BankingConciliationData, _CheckBanking, _ConciliationReport, _SetBanking, _StatementMovement, _UnCheckBanking, _UpdateBankingConciliation } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BankingConciliationReport } from "./BankingConciliationReport/BankingConciliationReport";
import { ConciliationStateConstantsselect } from "./BankingConciliationReport/ConciliationStateConstantsselect";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectRecurso } from "../../../Factoty&Production/LabourType/SelectRecurso";
import { BankingStatementMovementEditor } from "../BankingStatementMovement/BankingStatementMovementEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { BankingStatementEditor } from "../BankingStatementMovement/BankingStatementEditor";


export const BankingConciliation = () => {

    const BankingConciliation = useDataBean(_BankingConciliation);
    const BankingConciliationData = useDataBean(_BankingConciliationData);
    const updatebook = useDataBean(_UpdateBankingConciliation);
    const setBanking = useDataBean(_SetBanking);
    const check = useDataBean(_CheckBanking);
    const uncheck = useDataBean(_UnCheckBanking);
    const ApplyExtract = useDataBean(_Apply);
    const add = useDataBean(_AddBanking);
    const ConciliationReport = useDataBean(_ConciliationReport);
    const StatementMovement = useDataBean(_StatementMovement);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<{ url: string, name: string } | null>(null);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [listanueva, setListanueva] = useState<any>([]);
    const [listados, setListados] = useState<any>([]);
    const [listatres, setListatres] = useState<any>([]);
    const [listaresult, setListaresult] = useState<any>([]);
    const [BankingAccount, setBankingAccount] = useState<number>(null)
    const [IDtoBanking, setIDtoBanking] = useState<any>(null)
    const [state, setstate] = useState<any>(null)
    const paginador = usePaginator();
    const [modaleliminar, setModaleliminar] = useState<any>({ tabIndex: -1, view: false, btnClose: false, btnSubmit: true, format: 'modal-sm' });
    const [modalmodify, setModalmodify] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalmovimientos, setModalmovimientos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalreporte, setModalreporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalaccion, setModalaccion] = useState<any>({ tabIndex: -1, view: false, btnClose: false, btnSubmit: true, format: 'modal-lg' });
    const [show, setshow] = useState<any>(null)
    const [showtable, setshowtable] = useState<any>(null)
    const [modalapply, setModalaplly] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalextracto, setModalextracto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalconciliaciones, setModalconciliaciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (IDtoBanking) {
            Datawhitid();
        }
    }, [IDtoBanking]);
    useEffect(() => {
        if (modalaccion.view) {
            check.setBean({
                ...check.bean,
                IsApproving: null,
                IDBankingStatementMovement: null,
                BankingStatementMovement: null
            });
        }
    }, [modalaccion.view]);
    useEffect(() => {
        if (modalreporte.view) {
            getBankingConciliationReport();
        }
    }, [modalreporte.view]);
    useEffect(() => {
        if (modalextracto.view) {
            getBankingStatementMovement();
        }
    }, [modalextracto.view]);
    useEffect(() => {
        if (IDtoBanking) {
            Datawhitid();
        }
    }, [paginador.page]);

    const getBankingConciliationyear = () => {

        BankingConciliation.instance.getBankingConciliationDatawhityear(BankingAccount, year, month).then(
            (resp: any) => {
                if (resp.IDBankingConciliation) {
                    console.log(resp);
                    setListanueva(resp)
                    setshow(true)
                    const id = resp.IDBankingConciliation; // ✅ Aquí obtienes el ID
                    console.log("IDBankingConciliation:", id); // 👈 Aquí lo ves en consola}
                    setIDtoBanking(id)
                }
            }
        )

    }

    const getBankingStatementMovement = () => {
        StatementMovement.instance.getBankingStatementMovement(BankingConciliationData.bean.IDDocument, BankingConciliationData.bean.TrDate).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);
                    setListatres(resp)

                }
            }
        )

    }

    const getBankingConciliationReport = () => {
        ConciliationReport.instance.getBankingConciliationReport(IDtoBanking)
            .then((resp: any) => {
                if (resp && resp.length > 0) {
                    toast.success('Reporte');
                    setListados(resp);

                    const fileData = resp[0]?.DataBeanProperties;
                    if (fileData) {
                        setDocs({
                            url: fileData.URLLink,
                            name: fileData.Filename
                        });
                    }
                }
            })
            .catch(() => toast.error("No se pudo obtener el reporte"));
    };
    const addBankingConciliationDataInfo = () => {
        add.instance.addBankingConciliationDataInfo(IDtoBanking, add.bean.Description, add.bean.Date, add.bean.Value)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)

                    setModalmovimientos({ ...modalmovimientos, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo Agregar"));
    };
    const setBankingConciliationLeft = () => {
        setBanking.instance.setBankingConciliationLeft(IDtoBanking, setBanking.bean.BankingLeft)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    getBankingConciliationyear()
                    setModalmodify({ ...modalmodify, "view": false });
                    toast.success("Actualizado")
                }
            })
            .catch(() => toast.error("No se pudo Agregar"));
    };
    const applyBankingStatementToBankingConciliation = () => {
        ApplyExtract.instance.applyBankingStatementToBankingConciliation(IDtoBanking, ApplyExtract.bean.IDBankingStatement)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    getBankingConciliationyear()
                    setModalaplly({ ...modalapply, "view": false });
                    toast.success("Aplicado")
                }
            })
            .catch(() => toast.error("No se pudo Agregar"));
    };
    const updateBankingConciliationBookLeft = () => {
        updatebook.instance.updateBankingConciliationBookLeft(IDtoBanking)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    getBankingConciliationyear();
                }
            })
            .catch(() => toast.error("No se pudo Agregar"));
    };
    const head = [
        { title: 'ID', property: 'IDBankingConciliationData', visible: true, mask: MASK_NUMBER },
        { title: 'Estado', property: 'Estado', visible: true },
        { title: 'Fecha', property: 'TrDate', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Saldo Débito', property: 'DebtValue', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Crédito', property: 'LeftValue', visible: true, mask: MASK_MONEY },
    ]

    const headtwo = [
        { title: 'ID', property: 'IDBankingStatement', visible: true },
        { title: 'Oficina', property: 'Office', visible: true },
        { title: 'Consecutivo', property: 'DocumentConsecutive', visible: true },
        { title: 'Mnemonic', property: 'DocumentMnemonic', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Valor', property: 'TrValue', visible: true },
        { title: 'TrRef1', property: 'TrRef1', visible: true },
        { title: 'TrRef2', property: 'TrRef2', visible: true },
        { title: 'TrRef3', property: 'TrRef3', visible: true },
        { title: 'Fecha', property: 'TrDate', visible: true },

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Aplicar Movimiento a Conciliación', icono: 'ri-contacts-book-upload-fill', visible: single.canEdit(), evento: () => { setModalaccion({ ...modalaccion, "view": true }) } },
            { titulo: 'Consultar Extractos Bancarios Conciliados', icono: 'ri-phone-find-fill', visible: single.canEdit(), evento: () => { setModalextracto({ ...modalextracto, "view": true }) } },
            // { titulo: 'Eliminar Conciliación', icono: 'ri-phone-find-fill', visible: single.canEdit(), evento: () => { setModaleliminar({ ...modaleliminar, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const Datawhitid = () => {

        BankingConciliationData.instance.getBankingConciliationDatawhitid(IDtoBanking, state, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setshowtable(true)
                    // setLista(resp.List)
                    const datostrnas = resp.List.map((user: any) => {
                        user.DataBeanProperties.Estado = estadoFechaManifiesto(user.DataBeanProperties.StateName);
                        return user;
                    });
                    setListaresult(datostrnas)

                }
            }
        );
    };
    const estadoFechaManifiesto = (Estado: any): string => {
        if (!Estado) return 'SIN ESTADO';


        let message = '';

        if (Estado === "PENDIENTE") {
            message = "<span class='text-warning'>PENDIENTE</span>";
        } else if (Estado === "CONCILIADO") {
            message = "<span class='text-success'>CONCILIADO</span>";
        }

        // message += ` (${Estado})`;
        return message;
    };
    const editaItem = () => {
        //console.log(entailment.bean);
        BankingConciliationData.update().then(
            (resp: any) => {
                Datawhitid();

            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const checkBankingConciliationData = () => {

        check.instance.checkBankingConciliationData(BankingConciliationData.bean.IDBankingConciliationData, check.bean.IsApproving, check.bean.IDBankingStatementMovement).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)



                    setModalaccion({ ...modalaccion, "view": false });
                    Datawhitid();
                }
            }
        );
    };
    const uncheckBankingConciliationData = () => {

        uncheck.instance.uncheckBankingConciliationData(BankingConciliationData.bean.IDBankingConciliationData).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)



                    setModaleliminar({ ...modaleliminar, "view": false });
                    Datawhitid();
                }
            }
        );
    };
    const verbyyear = () => {

        setModalconciliaciones({ ...modalconciliaciones, "view": true });

    }
    const verbymob = () => {

        setModalmovimientos({ ...modalmovimientos, "view": true });

    }
    const cancelmov = () => {

        setModalaccion({ ...modalaccion, "view": false });


    }

    const verapply = () => {

        setModalaplly({ ...modalapply, "view": true });

    }
    const verbyREPORT = () => {

        setModalreporte({ ...modalreporte, "view": true });

    }
    const verbymodify = () => {

        setModalmodify({ ...modalmodify, "view": true });

    }
    const verREFRESH = () => {
        add.instance.refreshBankingConciliation(IDtoBanking)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    getBankingConciliationyear()
                }
            })
            .catch(() => toast.error("No se pudo Actualizar"));

    }
    const verLimpiar = () => {
        add.instance.uncheckBankingConciliation(IDtoBanking)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    getBankingConciliationyear()
                }
            })
            .catch(() => toast.error("No se pudo Actualizar"));

    }
    // ✅ Extraer los datos para mostrar
    const item = listanueva;
    const initial = item?.AuxiliaryLeft;
    const left = item?.BankingLeft;
    const pending = item?.PendingConciliation;

    return (
        <BasicPage titulo="Conciliación Bancaria">
            <div className="row">
                <div className="col-md-3">
                    <BankAccountSelect label="Cuenta Bancaria" idSelector={BankingAccount} onChange={(e) => { setBankingAccount(e) }} />
                </div>
                <div className="col-md-3">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-3">
                    <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                </div>
                <div className="col-md-3 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getBankingConciliationyear}>
                        Conciliar Banco
                    </BasicButton>
                </div>

                <div className="col-md-12">

                    {show && <>
                        <div className="col-md-12">

                            <div className="row">
                                <div className="col-md-12">
                                    <hr />
                                    <div className="col-md-4">
                                        <div className="row">
                                            <div className="col-md-2"><PrintJson json={IDtoBanking} /></div>
                                            <div className="col-md-10">
                                                <strong>ID Conciliación Bancaria</strong>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <BasicButton icon="ri-profile-line" clase="btn btn-outline-primary btn-border" eventClick={verbyyear}>
                                        Consultar Conciliaciones Bancarias
                                    </BasicButton>
                                </div>
                                <div className="col-md-3" >
                                    <BasicButton icon="ri-bar-chart-grouped-fill" clase="btn btn-outline-primary btn-border" eventClick={verbyREPORT}>
                                        Informe de Conciliación Bancaria
                                    </BasicButton>
                                </div>
                                <div className="col-md-3" >
                                    <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={verbymob}>
                                        Agregar Movimiento Períodos Anteriores
                                    </BasicButton>
                                </div>
                                <div className="col-md-3" >
                                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={updateBankingConciliationBookLeft}>
                                        Actualizar información de libro contable
                                    </BasicButton>
                                </div>
                                <div className="col-md-3 mt-4" >
                                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verapply}>
                                        Aplicar Automaticamente Extracto Bancario
                                    </BasicButton>
                                </div>
                                <div className="col-md-3 mt-4" >
                                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verbymodify}>
                                        Modificar Saldo Extracto Bancario
                                    </BasicButton>
                                </div>
                                <div className="col-md-3 mt-4" >
                                    <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={verREFRESH}>
                                        Actualización de la Conciliación Bancaria
                                    </BasicButton>
                                </div>
                                <div className="col-md-3 mt-4" >
                                    <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={verLimpiar}>
                                        Limpiar Conciliación Bancaria
                                    </BasicButton>
                                </div>
                                <div className="col-md-12 mt-4">
                                    <div className="alert alert-borderless shadow alert-secondary" role="alert">
                                        <div className="row">
                                            <div className="col-md-3"><strong>Valores de la Conciliación</strong></div>
                                            <div className="col-md-3">
                                                <div className="d-flex">
                                                    <strong>Saldo Libro Auxiliar de Bancos:</strong>
                                                    <span dangerouslySetInnerHTML={{ __html: single.formatFieldMask(initial, MASK_MONEY) }} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">

                                                <div className="d-flex">
                                                    <strong>Saldo Banco:</strong>
                                                    <span dangerouslySetInnerHTML={{ __html: single.formatFieldMask(left, MASK_MONEY) }} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex">
                                                    <strong>Pendiente por Conciliar:</strong>
                                                    <span dangerouslySetInnerHTML={{ __html: single.formatFieldMask(pending, MASK_MONEY) }} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <ConciliationStateConstantsselect idSelector={state} onChange={(e) => { setstate(e); }} />
                                </div>
                                <div className="col-md-2 mt-4 p-2">
                                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={Datawhitid}>
                                        Consultar
                                    </BasicButton>
                                </div>
                            </div>
                            {/* <PrintJson json={listados} /> */}

                        </div>
                    </>}
                    {showtable && <>
                        <label>Lista de transacciones a conciliar</label>
                        <BasicTable body={listaresult} head={head} rowSet={(e) => { BankingConciliationData.setBean(e); }} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </>}

                </div>
                <div className="col-md-12">
                    <Modal modal={modalaccion} updateModal={setModalaccion}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <BasicSwitch label="Seleccionar Movimiento de Extracto Bancario?" estado={check.bean.IsApproving} eventChange={(e) => { check.setBean({ ...check.bean, "IsApproving": e }) }}></BasicSwitch>
                                </div>
                                {check.bean.IsApproving && <>
                                    <div className="col-md-6 mt-4">
                                        <label>Aplicar Movimiento a Conciliación</label>
                                        <BankingStatementMovementEditor BankingAccount={BankingAccount} TrValue={BankingConciliationData.bean.TrValue} render={check.bean.BankingStatementMovement} idSelector={check.bean.IDBankingStatementMovement} onChange={(e) => { check.setBean({ ...check.bean, "IDBankingStatementMovement": e.IDBankingStatementMovement, "BankingStatementMovement": e.IDBankingStatementMovement }) }} label=" " returnType="Object" />
                                    </div></>}
                                <div className="col-md-12 mt-4">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-success btn-border" eventClick={checkBankingConciliationData}>
                                                Aplicar Movimiento a Conciliación
                                            </BasicButton>
                                        </div>
                                        <div className="col-md-6">
                                            <BasicButton icon="ri-add-circle-line" clase="btn btn-soft-danger btn-border" eventClick={cancelmov}>
                                                Cancelar Movimiento
                                            </BasicButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalextracto} updateModal={setModalextracto} >
                        <>
                            <div className="row">
                                <div className="col-md-12">

                                    <BasicTable head={headtwo} body={listatres} rowSet={(e) => { StatementMovement.setBean(e) }}></BasicTable>

                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalreporte} updateModal={setModalreporte} >
                        <>
                            {/* <PrintJson json={docs} /> */}
                            <div className="row">
                                {docs && (
                                    <div className="row mt-3">
                                        <div className="col-md-12 text-center">
                                            <a
                                                href={docs.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-link"
                                            >
                                                📄  {docs.name || "Abrir archivo"}
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalmovimientos} updateModal={setModalmovimientos} eventModal={addBankingConciliationDataInfo}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <InputDate name="Date" label="Fecha del Movimiento" value={add.bean.Date} setDate={(e: any) => { add.setBean({ ...add.bean, "Date": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Valor</label>
                                    <InputMoney _value={add.bean.Value} onChange={(e: any) => { add.setBean({ ...add.bean, 'Value': e }) }} />
                                    {/* <input type="text" name="Value" className="form-control" value={add.bean.Value} onChange={add.handleChange} /> */}
                                </div>
                                <div className="col-md-12">
                                    <label>Descrición</label>
                                    <textarea name="Description" className="form-control" value={add.bean.Description} onChange={add.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalapply} updateModal={setModalaplly} eventModal={applyBankingStatementToBankingConciliation}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <strong>Extracto Bancario</strong>
                                    <BankingStatementEditor BankingAccount={BankingAccount} render={ApplyExtract.bean.BankingStatement} idSelector={ApplyExtract.bean.IDBankingStatement} onChange={(e) => { console.log(e); ApplyExtract.setBean({ ...ApplyExtract.bean, "IDBankingStatement": e.IDBankingStatement, "BankingStatement": e.IDBankingStatement }) }} label=" " returnType="Object" />
                                </div>
                                {/* <PrintJson json={ApplyExtract.bean} /> */}
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalmodify} updateModal={setModalmodify} eventModal={setBankingConciliationLeft}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Saldo en Extracto Bancario</label>
                                    <InputMoney _value={setBanking.bean.BankingLeft} onChange={(e: any) => { setBanking.setBean({ ...setBanking.bean, 'BankingLeft': e }) }} />
                                    {/* <input type="text" name="BankingLeft" className="form-control" value={setBanking.bean.BankingLeft} onChange={setBanking.handleChange} /> */}
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalconciliaciones} updateModal={setModalconciliaciones} >
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <BankingConciliationReport />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaleliminar} updateModal={setModaleliminar} >
                        <>
                            <div className="row">
                                <strong>Eliminar Conciliación ?</strong>
                                <div className="col-md-12 mt-4">
                                    <BasicButton icon="ri-add-circle-line" clase="btn btn-soft-danger btn-border" eventClick={uncheckBankingConciliationData}>
                                        Eliminar
                                    </BasicButton>
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}